import { supabase } from './supabase';
import { normalizePhoneDigits } from '../utils/validation';

export const DUPLICATE_PHONE_MESSAGE =
  'A contact with this phone number already exists.';

export interface CustomerPhoneMatch {
  id: number;
  name: string;
  phone: string | null;
}

/** Find an existing contact by normalized 10-digit phone (ignores +91 / spacing). */
export async function findCustomerByPhone(
  phone: string | null | undefined,
): Promise<CustomerPhoneMatch | null> {
  if (normalizePhoneDigits(phone).length !== 10) return null;

  const { data, error } = await supabase.rpc('find_customer_by_phone', {
    p_phone: phone?.trim() ?? '',
  });
  if (error) throw error;

  const row = (Array.isArray(data) ? data[0] : data) as CustomerPhoneMatch | undefined;
  return row ?? null;
}

export async function assertPhoneNotDuplicate(
  phone: string | null | undefined,
  excludeId?: number,
): Promise<void> {
  const existing = await findCustomerByPhone(phone);
  if (existing && existing.id !== excludeId) {
    throw new Error(DUPLICATE_PHONE_MESSAGE);
  }
}
